import Box from '@mui/material/Box';

type Props = {
  /** 0–1 through the clip. */
  value: number;
};

/**
 * How far through the clip we are.
 *
 * Not a slider: there is nothing to drag. A clip in this feed is ten to thirty
 * seconds long and loops, so a scrub handle would be a control for seeking
 * four seconds into something that is about to start again — and a draggable
 * handle at the foot of a vertical scroller is a gesture conflict with the
 * feed itself. It is a progress indicator, which is why it is `aria-hidden`
 * and not a `progressbar`: a screen-reader user is not served by being told a
 * silent video is 40% done four times a second.
 *
 * The width is set directly with no transition. It is already updated once per
 * frame by the hook that owns the video, so a transition on top of that would
 * be interpolating towards a value that has already changed — which shows as
 * lag, not smoothness.
 */
export function ReelProgress({ value }: Props) {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 3,
        bgcolor: 'rgba(255, 255, 255, 0.22)',
        zIndex: 3,
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${Math.min(Math.max(value, 0), 1) * 100}%`,
          bgcolor: '#FFFFFF',
        }}
      />
    </Box>
  );
}
